import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import config from "../../../../application/config/config";
import Fetch from "../../../util/core/Fetch";
import "./PermissionTreeview.css";
import CustomModal from "../Util/Modal/CustomModal";
import moment from 'moment'

const TreeViewNode = ({ data, handleCheckboxChange, disabled = false }) => {
  const [expanded, setExpanded] = useState(true);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  const firstLayer = data.children && data.children.length > 0 ? 'first-layer' : '';
  const secondLayer = data.children && data.children.some(d => d.children && d.children.length > 0) ? 'second-layer' : '';

  return (
    <li className="w-100">
      <div className="row align-items-center">
        {data.children && data.children.length > 0 ? (
          <a href="#" className={`nav-link col-lg-1`} onClick={handleToggle}>
            {expanded ? (
              <i className="fas fa-angle-down" />
            ) : (
              <i className="fas fa-angle-right" />
            )}
          </a>
        ) : (
          <span className="nav-link col-lg-1">
            <i className="fa-solid fa-circle-dot" />
          </span>
        )}

        <div className={`col-lg-4 ${firstLayer} ${secondLayer}`}>
          <span>{data.title}</span>
        </div>

        <div className="col-lg-7 d-flex justify-content-center">
          <div className="form-check form-check-inline" style={{ maxWidth: 150 }}>
            <div className="checkbox-container" >
              <input
                disabled={disabled}
                checked={data.canViewMenuMobile}
                type="checkbox"
                name="canViewMenuMobile"
                id={"canViewMenuMobile" + data._id}
                className="form-check-input-switch"
                onChange={(e) => handleCheckboxChange(e, data._id)}
              />
              <label htmlFor={"canViewMenuMobile" + data._id} />
            </div>
          </div>
        </div>
      </div>
      {data.children && data.children.length > 0 && expanded && (
        <ul className={`nav nav-treeview ${firstLayer} ${secondLayer}`}>
          {data.children?.map((child, index) => (
            <TreeViewNode
              key={child.title}
              data={child}
              index={index}
              layer={'second-layer'}
              handleCheckboxChange={handleCheckboxChange}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

const TreeView = ({
  disabled = false,
  permission,
  setPermission,
  allPermissions,
  setAllPermissions,
  endpointGetById,
  handleChange,
  fromUser,
  activeTab
}) => {
  const { id } = useParams();
  const menuSession = useSelector(
    (state) => state.core.session["core-sorteable-data-menu_mobile"]
  );
  const [showModalDatePermission, setShowModalDatePermission] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalTitle, setModalTitle] = useState('Titulo do Modal');
  const [applicationProfileData, setApplicationProfileData] = useState({});

  const handleConfirm = async () => {
    await Fetch.put(config.endpoints.backend + 'core/users/updatepermissions', {restore: true, id, permissions: applicationProfileData.permissions})
    setShowModalDatePermission(false)
  }

  useEffect(() => {
    const updatePermissions = async () => {
      let permissions = [];
      let tempMenu = menuSession ? [...menuSession] : [];

      if (id) {
        const response = await Fetch.post(endpointGetById, { id });
        permissions = response.permissions_mobile;
        if(fromUser){
          tempMenu = [...response.permissions_mobile]
          if(response.permissions_updated_per_user === '1'){
            const updatedDatePermissionUser = moment(response.permissions_updated_date)
            
            const applicationProfile = await Fetch.post(config.endpoints.backend + "core/applicationsprofiles/getById", {id: response.application_profile_id})
            
            const updatedDateProfile = moment(applicationProfile.updatedAt)

            if(updatedDatePermissionUser.isBefore(updatedDateProfile)){
              setShowModalDatePermission(true)
              setModalContent(
                <div>
                  <p>O perfil de acesso {applicationProfile.profile_name} foi atualizado com novas funcionalidades, deseja restaurar as configurações padrões deste perfil de acesso?</p>
                </div>
              )
              setModalTitle('Atenção')

              setApplicationProfileData(applicationProfile)
              
            }
          }
        }
      }

      const functionalities = await Fetch.post(
        config.endpoints.backend + "core/applicationsfunctionalities/getall"
      );

      const getPermissions = (menus, permissions) => {
        return menus.map((menu, index) => {
          if (menu.functionality_id) {
            let functionality = functionalities.filter(
              (functionality) => functionality.id == menu.functionality_id
            );

            functionality = functionality[0];
            menu.path =
              functionality && functionality.path ? functionality.path : "";
            menu.prefix = functionality ? functionality.prefix || null : null;
          }
          let item = { ...menu };

          permissions?.map((item2) => {
            if (menu._id == item2._id) {
              item.canViewMenuMobile = item2.canViewMenuMobile ? true : false;
            }
          });

          if (menu.children && menu.children.length > 0) {
            if (permissions[index] && permissions[index].children) {
              item.children = getPermissions(
                menu.children,
                permissions[index].children
              );
            } else {
              item.children = getPermissions(menu.children, menu.children);
            }
            return item;
          } else {
            return item;
          }
        });
      };

      const updatedPermissions = getPermissions(tempMenu, permissions);
      setPermission(updatedPermissions);
    };

    updatePermissions();
  }, [menuSession]);

  useEffect(() => {
    const updateAllPermissions = async () => {
      if (!permission.length) return;
    
      const permissionsUnify = permission.reduce((acc, item) => {
        if (item.children && item.children.length > 0) {
          item.children.forEach((it) => {
            if (it.children && it.children.length > 0) {
              acc.push(it);
    
              it.children.forEach((i) => {
                acc.push(i);
              });
            } else {
              acc.push(it);
            }
          });
        }
    
        acc.push(item);
        return acc;
      }, []);

      const checkAllPermissions = (key) => {
        return permissionsUnify.every((item) => item[key]);
      };

      setAllPermissions({
        canViewMenuMobile: checkAllPermissions("canViewMenuMobile"),
      });
    };

    updateAllPermissions();
  }, [permission]);

  const handleCheckboxChange = (e, identifier) => {
    const { name, checked } = e.target;
    const updateItemPermissions = (items) => {
      return items?.map((item) => {
        if (item._id === identifier) {
          item = { ...item, [name]: checked };
          return item;
        }

        if (item.children && item.children.length > 0) {
          return { ...item, children: updateItemPermissions(item.children) };
        }
        return item;
      });
    };

    const updatedArray = updateItemPermissions(permission);
    setPermission(updatedArray);
    handleChange(updatedArray);
  };

  const handleAllCheckboxChange = (e) => {
    const { name, checked } = e.target;
  
    const updateItemPermissions = (items) => {
      return items?.map((item) => {
        const updatedItem = (item = { ...item, [name]: checked });
  
        if (item.children && item.children.length > 0) {
          updatedItem.children = updateItemPermissions(item.children);
        }
  
        return updatedItem;
      });
    };
  
    const updatedArray = updateItemPermissions(permission);
    setPermission(updatedArray);
    handleChange(updatedArray);
  };

  return (
    <>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1></h1>
            </div>
          </div>
        </div>
        {/* /.container-fluid */}
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            {/* left column */}
            <div className="col-md-12">
              <div className="card card-outline card-info">
                <div className="card-header">
                  <h3 className="card-title">
                    <i className="fa-solid fa-pen-to-square mr-1"></i>{" "}
                    Permissionamento
                  </h3>
                </div>
                {/* /.card-header */}
                {/* form start */}
                <div className="container mt-5 container-permission">
                  <ul id="treeview" className="nav nav-treeview">
                    <li className="w-100">
                      {permission && permission.length > 0 && (
                        <div className="row align-items-center">
                          <span className="nav-link col-lg-1" />
                          <div className="col-lg-4" />
                          <div className="col-lg-7 d-flex justify-content-center select-all-buttons">
                            <div className="form-check form-check-inline" style={{ maxWidth: 150 }}>
                              <div className="checkbox-container">
                                <input
                                  disabled={disabled}
                                  checked={allPermissions.canViewMenuMobile}
                                  type="checkbox"
                                  name="canViewMenuMobile"
                                  id="canViewMenuMobile"
                                  className="form-check-input"
                                  onChange={(e) => handleAllCheckboxChange(e)}
                                />
                                <label
                                  htmlFor="canViewMenuMobile"
                                  className="checkmark-permission"
                                />
                              </div>
                              <label className="form-check-label-permission">Todos</label>
                            </div>
                          </div>
                        </div>
                      )}
                    </li>
                    {permission &&
                      permission.length > 0 &&
                      permission?.map((item) => (
                        <>
                          <TreeViewNode
                            data={item}
                            key={item._id}
                            disabled={disabled}
                            handleCheckboxChange={handleCheckboxChange}
                          />
                        </>
                      ))}
                  </ul>
                </div>
              </div>
              {/* /.card */}
            </div>
            {/*/.col (left) */}
            {/* right column */}
            <div className="col-md-6"></div>
            {/*/.col (right) */}
          </div>
          {/* /.row */}
        </div>
        {/* /.container-fluid */}
      </section>
      {(activeTab === 'list' && fromUser) && <CustomModal show={showModalDatePermission} content={modalContent} handleCancel={() => setShowModalDatePermission(false)} handleConfirm={() => handleConfirm()} handleClose={() => {}} title={modalTitle}/>}
    </>
  );
};

export default TreeView;
